// extracted by mini-css-extract-plugin
module.exports = {"jsonBody":"jsonBody--index--kteC87z"};